import { App, Button, Card, Col, Flex, Form, Input, Modal, Row, Typography } from "antd";
import { theme } from "antd";
import { useMutation } from "@tanstack/react-query";
import { UsuarioService } from "../../Services/UsuarioService";
import { AxiosError } from "axios";
import { useContext, useEffect, useState } from "react";
import { SessaoContext } from "../../Contexts/SessaoContext";
import { configurarSessaoDoAxios } from "../../Services/Axios";
import { LOCAL_STORAGE_JWT_KEY } from "../../Constants";
import React from "react";
import { useForm } from "antd/es/form/Form";
import { PropriedadesDeNotificacao } from "../../Utils/Notificacoes";
import { TypeUsuario } from "../../Models/Usuario";

type TypeLogin = { usuario: string, senha: string }


const PainelDePrimeiraSenha: React.FC<{ 
    temaEscuro?: boolean,
    autenticacao: TypeLogin
}> = (props) => {

    const send = App.useApp();

    interface IFormularioDePrimeiraSenha {
        usuario: string,
        senhaAtual: string,
        novaSenha: string,
        novaSenhaConf: string
    }

    const Sessao = useContext(SessaoContext);
    const mutationPrimeiraSenha = useMutation({
        mutationFn: (valores: IFormularioDePrimeiraSenha) => new UsuarioService().configurarPrimeiraSenha({...valores, senhaAtual: props.autenticacao.senha}),
        onSuccess: (data) => {
            if (!data.data.token) return;

            localStorage.setItem(LOCAL_STORAGE_JWT_KEY, data.data.token);
            configurarSessaoDoAxios(
                data.data.token,
                () => {
                    localStorage.setItem(LOCAL_STORAGE_JWT_KEY, "");
                    Sessao?.setSessao((prev) => ({ ...prev, token: undefined }));
                });

            Sessao?.setSessao(data.data);
            send.notification.success({ message: "Senha alterada com sucesso!" });
        },
        onError: (error: AxiosError) => {
            const status = error.response?.status;
            if (status == 401 ) {
                send.notification.error({message: "Usuário ou senha incorretos. Verifique as credenciais fornecidas."})
            }
            else if (status == 403 && error.response?.data && typeof error.response.data == "string") {
                send.notification.error({message: error.response.data})
            } 
            else {
                send.notification.error({ message: "Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde." });
            }
        }
    });

    const [formPrimeiraSenha] = useForm<IFormularioDePrimeiraSenha>();

    useEffect(() => {
        formPrimeiraSenha.setFieldValue("usuario", props.autenticacao.usuario);
        // formPrimeiraSenha.setFieldValue("senhaAtual", props.autenticacao.senha);
    }, [props])

    return <React.Fragment>
        <Row gutter={16} style={{gap: "1em"}}>
           <Col xs={24}>
                <img alt="Logo Quiron" src={props.temaEscuro ? require('../../Assets/logo-quiron-branco.png') : require('../../Assets/logo-quiron.png')} style={{ width: '140px', textAlign: 'center' }} />
            </Col>

            <Col xs={24}>
                <Typography.Paragraph strong>
                    <Typography.Text>
                        Este é seu primeiro acesso. Defina uma senha para continuar.
                    </Typography.Text>
                </Typography.Paragraph>
            </Col>
        </Row>

        <Row>
            <Form<IFormularioDePrimeiraSenha>
                form={formPrimeiraSenha}
                autoComplete="off"
                layout="vertical"
                onFinish={(valores) => {
                    mutationPrimeiraSenha.mutate(valores);
                }}
                style={{
                    flexGrow: 1,
                    minWidth: "260",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em"
                }}
            >

                <Form.Item<IFormularioDePrimeiraSenha>
                    label="Usuário"
                    name="usuario"
                    required
                >
                    <Input disabled={true} />
                </Form.Item>

                <Form.Item<IFormularioDePrimeiraSenha>
                    name="novaSenha"
                    required
                    rules={[
                        {
                            required: true,
                            min: 8,
                            message: <> - Deve ter no mínimo 8 caracteres</>
                        },
                        {
                            required: true,
                            pattern: /[A-Z]/,
                            message: <> - Deve ter um caractere maiúsculo</>
                        },
                        {
                            required: true,
                            pattern: /[a-z]/,
                            message: <> - Deve ter um caractere minúsculo</>
                        },
                        {
                            required: true,
                            pattern: /[0-9]/,
                            message: <> - Deve ter um digito</>
                        },
                        {
                            required: true,
                            pattern: /[!@#\$%\^&\*]/,
                            message: <> - Deve ter um caractere especial (!@#$%^&*) </>
                        },

                    ]}
                >
                    <Input.Password placeholder="Nova senha" ></Input.Password>
                </Form.Item>

                <Form.Item<IFormularioDePrimeiraSenha>
                    name="novaSenhaConf"
                    required
                    rules={[
                        {
                            validator: async (_, val: string) => {
                                if (val != formPrimeiraSenha.getFieldsValue().novaSenha) {
                                    return Promise.reject(<>As senhas não conicidem</>);
                                }
                            },
                        }
                    ]}
                >
                    <Input.Password placeholder="Confirmar senha" visibilityToggle={false} ></Input.Password>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={mutationPrimeiraSenha.isPending} block>
                        Avançar
                    </Button>
                </Form.Item>

            </Form>
        </Row>
    </React.Fragment>
}

const PainelDeLogin: React.FC<{temaEscuro?: boolean, aoExigirPrimeiraSenha: (valores: TypeLogin) => any}> = (props) => {
    const { notification } = App.useApp();
    const Sessao = useContext(SessaoContext);

    const [exibirModalDeRecuperacaoDeSenha, setExibirModalDeRecuperacaoDeSenha] = useState<boolean>(false);

    interface IRecuperacaoDeSenha { usuario: TypeUsuario["usuario"] }
    const [formRecuperacaoDeSenha] = useForm<IRecuperacaoDeSenha>();

    const mutationLogin = useMutation({
        mutationFn: (dadosLogin: TypeLogin) => new UsuarioService().logar(dadosLogin),
        onSuccess: (data) => {
            if (!data.data.token) return;

            localStorage.setItem(LOCAL_STORAGE_JWT_KEY, data.data.token);
            configurarSessaoDoAxios(
                data.data.token,
                () => {
                    localStorage.setItem(LOCAL_STORAGE_JWT_KEY, "");
                    Sessao?.setSessao((prev) => ({ ...prev, token: undefined }));
                });

            Sessao?.setSessao(data.data);
        },
        onError: (error: AxiosError, valores) => {
            if (error.response?.status === 401) {
                notification.error({ message: "Usuario ou senha inválidos.", placement: "top" });
            }
            else if (error.response?.status === 428 && (error.response.data as any).alterarSenha) {
                notification.info({ message: "É necessário definir sua primeira senha", placement: "top" });

                props.aoExigirPrimeiraSenha(valores);
            }
            else {
                notification.error({ message: "Ocorreu um erro tente novamente mais tarde.", placement: "top" });
            }
        }
    });

    return <React.Fragment>
        
        <Modal footer={false} title={"Esqueceu sua senha"} open={exibirModalDeRecuperacaoDeSenha}
        onCancel={() => {
            setExibirModalDeRecuperacaoDeSenha(false);
        }}
        >
            <Form
                form={formRecuperacaoDeSenha}
                layout="vertical"
                autoComplete="off"
                onFinish={(valores) => {
                    new UsuarioService().recuperarSenha(valores.usuario)
                        .then(() => {
                            notification.success({
                                ...PropriedadesDeNotificacao.Sucesso("Um e-mail contendo as informações de recuperação foi enviado para o e-mail associado à conta.")
                            })
                            setExibirModalDeRecuperacaoDeSenha(false);
                        })
                        .catch(() => {})
                }}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em"
                }}

            >
                <Form.Item<IRecuperacaoDeSenha>
                    label="Usuario"
                    name="usuario"
                    rules={[
                        { required: true, message: "Informe seu usuário." },
                        {/* 
                        { required: true, validator: async (rule, value, cb) => {
                            const disponibilidade =  await new UsuarioService().verificarDisponibilidade({
                                nomeDeUsuario: formRecuperacaoDeSenha.getFieldsValue().usuario
                            })
                            console.log(disponibilidade)
                            if(!!disponibilidade.data.nomeDeUsuario){
                                return Promise.reject("Nenhum usuário encontrado.");
                            }

                        }}
                    */}
                ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item style={{marginBottom: 0}}>
                    <Button type="primary" htmlType="submit" loading={mutationLogin.isPending} block>Confirmar</Button>
                </Form.Item>
            </Form>

        </Modal>

        <Form
            name="login"
            onFinish={(valores) => mutationLogin.mutate(valores)}
            autoComplete="on"
            layout="vertical"
            style={{ minWidth: '260px', flexGrow: 1 }}
        >
            <Form.Item style={{ display: "flex", justifyContent: "center" }}>
                <img alt="Logo Quiron" src={props.temaEscuro ? require('../../Assets/logo-quiron-branco.png') : require('../../Assets/logo-quiron.png')} style={{ width: '140px', textAlign: 'center' }} />
            </Form.Item>
            <Form.Item<TypeUsuario>
                label="Usuario"
                name="usuario"
                rules={[{ required: true, message: "Informe seu usuário." }]}
            >
                <Input></Input>
            </Form.Item>
            <Form.Item<TypeUsuario>
                label="Senha"
                name="senha"
                rules={[{ required: true, message: "Informe sua senha." }]}
            >
                <Input.Password></Input.Password>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
                <Flex vertical>
                    <Button type="primary" htmlType="submit" loading={mutationLogin.isPending} block>Entrar</Button>

                    <Button type="link" onClick={() => {
                        setExibirModalDeRecuperacaoDeSenha(true);
                    }}> Esqueceu sua senha? </Button>
                </Flex>
            </Form.Item>

        </Form>
    </React.Fragment>
}

export function Login(props: {
    temaEscuro: boolean,
    telaInteira?: boolean
}) {

    const [propriedadesDoPainelDePrimeiraSenha, setPropriedadesDoPainelDePrimeiraSenha] = useState<{ exibir: boolean, info?: TypeLogin }>({
        exibir: false,
    });


    const PainelPrincipal = () => {
        return propriedadesDoPainelDePrimeiraSenha.exibir && propriedadesDoPainelDePrimeiraSenha.info ?
            <PainelDePrimeiraSenha
                temaEscuro={props.temaEscuro}
                autenticacao={propriedadesDoPainelDePrimeiraSenha.info}
            />
            :
            <PainelDeLogin aoExigirPrimeiraSenha={(valores) => {
                setPropriedadesDoPainelDePrimeiraSenha({ exibir: true, info: valores });
            }} />
    }

    return !props.telaInteira ?
        <PainelPrincipal/> :
        <>
            <style>
                {`
                .loginBackground{
                    background: linear-gradient(-45deg, ${theme.useToken().token.colorPrimary} 30%, ${theme.useToken().token.colorBgBase} 70%);
                    background-size: 150% 150%;
                    animation: gradient 10s ease infinite;
                    height: 100vh;
                }
                @keyframes gradient {
                    0% {
                      background-position: 0% 50%;
                    }
                    50% {
                      background-position: 50% 75%;
                    }
                    100% {
                      background-position: 0% 50%;
                    }
                }`
                }
            </style>
            <Flex justify="center" align="center" className="loginBackground">
                <Card>
                    <PainelPrincipal/>
                </Card>
            </Flex>
        </>

}